import { Divider, Flex, Typography } from "antd";
import { ItemInfoBlock } from "components";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useStores } from "stores";
import { getBidInfo, getUserInfo } from "./columns";
type Props = {
  isExecuteModal?: boolean;
  showAddressWallet?: boolean;
};

export const CustomerExecutionModalBody = observer(({ isExecuteModal = true, showAddressWallet = false }: Props) => {
  const { bidCard, user, quotes } = useStores();
  const { quoteSelectedData } = quotes;

  const { bidInfo, contractCompanyInfo, walletInfo } = useMemo(() => {
    return getBidInfo({
      bidCard,
      quoteSelectedData,
      user,
      isExecuteModal,
      showAddressWallet,
    });
  }, [bidCard.bid, isExecuteModal, showAddressWallet, quoteSelectedData]);

  const userInfo = useMemo(() => {
    return getUserInfo(user);
  }, [user.userInfo]);

  return (
    <Flex vertical>
      {isExecuteModal && (
        <>
          <Divider />
          <Typography.Text className="text-lg" strong>
            Платежное поручение на перевод средств в исполнение заявки
          </Typography.Text>
        </>
      )}
      <Divider className={isExecuteModal ? "margin-bottom-sm" : "margin-bottom-sm margin-top-none"} />
      <ItemInfoBlock items={bidInfo} blockTitle="Данные заявки" oneColumn vertical={false} />
      {!!contractCompanyInfo.length && (
        <>
          <Divider className="margin-top-none margin-bottom-sm" />
          <ItemInfoBlock items={contractCompanyInfo} blockTitle="Контрагент" oneColumn vertical={false} />
        </>
      )}
      <Divider className="margin-top-none margin-bottom-sm" />
      <ItemInfoBlock items={walletInfo} blockTitle="Цифровая валюта" oneColumn vertical={false} />
      <Divider className="margin-top-none margin-bottom-sm" />
      <ItemInfoBlock items={userInfo} oneColumn vertical={false} />
    </Flex>
  );
});
